import { useMyOrgGisSetup } from 'src/layouts/AppStateContextLayout/utils'
import { useIsApprovalConditionsEnabled } from 'src/utils/featureFlagging/featureFlagging'

/** Statsig Approval Conditions + Entity Versions GIS (parcel/address Conditions tab + related UI). */
const useShowConditionsUi = (): boolean => {
  const isApprovalConditionsEnabled = useIsApprovalConditionsEnabled()
  const orgGisSetup = useMyOrgGisSetup()
  return isApprovalConditionsEnabled && orgGisSetup === 'EntityVersions'
}

export default useShowConditionsUi
